import { makeStyles } from '@material-ui/core/styles'
import React, { useState, useEffect } from 'react';
import { Box, Dialog, DialogContent, Button, useTheme } from '@material-ui/core';
import { useDataProvider, Loading } from 'react-admin';
import IconRadiusButton from '../CustomizedUIs/IconRadiusButton';
import { Close, NavigateNext, NavigateBefore } from '@material-ui/icons'
import { isImage, isVideo, calcuMediaWidth, calcuMediaHeight } from '../utils';
import { baseAuthUrl } from '../authProvider';
import icDefault from '../assets/icons/favicon.png'
import classnames from 'classnames';
import Iframe from 'react-iframe';
import CloseButton from '../CustomizedUIs/CloseButton';

const useStyles = makeStyles(theme => ({
    FullContainer: {
        width: '100%',
        height: '100%',
    },
    DialogContentPresenter: {
        overflow: 'hidden',
        border: '3px solid grey',
        position: "relative",
        marginLeft: 'auto',
        marginRight: 'auto'
    },
    ControlPresenter: {
        padding: '2vh 40%',
        overflow: 'hidden',
        '& button:hover': {
            backgroundColor: '#ddd',
            color: 'black'
        }
    },
    overlayEditor: {
        position: 'absolute',
        top: 0,
        left: 0,
        margin: 0,
        border: 'none'
    },
    VideoPresenter: {
        overflow: 'hidden',
        border: '3px solid grey',
        backgroundColor: 'black'
    },
    ImagePresenter: {
        overflow: 'hidden',
        border: '3px solid grey',
        backgroundColor: 'black'
    },
    NumberMark: {
        position: 'absolute',
        left: 0,
        right: 0,
        color: 'white'
    },
}));

const useOtherStyle = makeStyles({
    zoom: zoomRate => ({
        '-ms-zoom': `${zoomRate.width}`,
        '-moz-transform': `scale(${zoomRate.width}, ${zoomRate.height})`,
        MozTransformOrigin: '0 0', OTransform: `scale(${zoomRate.width}, ${zoomRate.height})`,
        OTransformOrigin: '0 0', WebkitTransform: `scale(${zoomRate.width}, ${zoomRate.height})`,
        WebkitTransformOrigin: '0 0',
        transform: `scale(${zoomRate.width}, ${zoomRate.height})`,
        transformOrigin: '0 0'
    })
});

const PresenterContain = (props) => {
    const { presenterData, screenSize, presentData, pivot, classData, isSound } = props;
    const filePath = !presenterData.owner && !presenterData.file ? presenterData.fd : baseAuthUrl + "/media/" + presenterData.fd;

    useEffect(() => {
        presentData();
    }, [presenterData]);

    if (presenterData) {
        const _isVideo = isVideo(presenterData.type || presenterData.fd.split('.')[presenterData.fd.split('.').length - 1]);
        const _isImage = !isVideo || isImage(presenterData.type);
        if (_isVideo) {
            return (

                <Box>
                    {/*<h1 className={props.classData.NumberMark}>{props.selectedIndex}</h1>*/}
                    <video muted={isSound} id="videoPresenter" key={filePath} style={{
                        transform: `rotate(${presenterData.rotate}deg)`,
                        width: `${props.resolution !== 'No pre-scaling' ? `${screenSize.width + 'px'}` : calcuMediaWidth(presenterData.dimension, screenSize, pivot, presenterData.rotate, props.resolution === 'No pre-scaling')}`,
                        height: `${props.resolution !== 'No pre-scaling' ? `${screenSize.height + 'px'}` : calcuMediaHeight(presenterData.dimension, screenSize, pivot, presenterData.rotate, props.resolution === 'No pre-scaling')}`,
                        position: `${props.resolution === 'No pre-scaling' ? 'absolute' : ''}`,
                        top: `${props.resolution === 'No pre-scaling' ? 0 : 0}`,
                        bottom: `${props.resolution === 'No pre-scaling' ? 0 : 0}`,
                        left: `${props.resolution === 'No pre-scaling' ? 0 : 0}`,
                        right: `${props.resolution === 'No pre-scaling' ? 0 : 0}`,
                        margin: `${props.resolution === 'No pre-scaling' ? 'auto' : ''}`
                    }} src={filePath} />
                </Box>
            );
        }
        if (_isImage) {
            return (
                <Box>
                    {/*<h1 className={props.classData.NumberMark}>{props.selectedIndex}</h1>*/}
                    <img id="imagePresenter" key={filePath} style={{
                        transform: `rotate(${presenterData.rotate}deg)`,
                        width: `${props.resolution !== 'No pre-scaling' ? `${screenSize.width + 'px'}` : calcuMediaWidth(presenterData.dimension, screenSize, pivot, presenterData.rotate, props.resolution === 'No pre-scaling')}`,
                        height: `${props.resolution !== 'No pre-scaling' ? `${screenSize.height + 'px'}` : calcuMediaHeight(presenterData.dimension, screenSize, pivot, presenterData.rotate, props.resolution === 'No pre-scaling')}`,
                        position: `${props.resolution === 'No pre-scaling' ? 'absolute' : ''}`,
                        top: `${props.resolution === 'No pre-scaling' ? 0 : 0}`,
                        bottom: `${props.resolution === 'No pre-scaling' ? 0 : 0}`,
                        left: `${props.resolution === 'No pre-scaling' ? 0 : 0}`,
                        right: `${props.resolution === 'No pre-scaling' ? 0 : 0}`,
                        margin: `${props.resolution === 'No pre-scaling' ? 'auto' : ''}`
                    }} src={filePath} />
                </Box>
            )
        }
    }

    return (
        <Box className={classData.FullContainer}>
            {/*<h1 className={props.classData.NumberMark}>No File</h1>*/}
            <img className={`${classData.ImagePresenter} ${classData.FullContainer}`} src={icDefault} />
        </Box>
    )
};
let _currentInterval = null;
let _stickDisplayTime = 0;
const PreviewScheduleDialog = (props) => {
    const { open, resolution, pivot = false, scheduleData, handleClose, sound } = props;
    const classes = useStyles();
    const dataProvider = useDataProvider()
    const theme = useTheme();
    const [selectedPresenter, setSelectedPresenter] = useState(0);
    const [presenterData, setPresenterData] = useState([]);
    const [soundValue, setSoundValue] = useState()
    const [loading, setLoading] = useState(false)
    const screenSize = {
        width: pivot ? 360 : 960,
        height: pivot ? 640 : 540
    }
    const zoomRate = {
        width: resolution ? screenSize.width / (resolution.split('x').length > 1 ? resolution.split('x')[pivot ? 1 : 0] : '1280') : 1,
        height: resolution ? screenSize.height / (resolution.split('x').length > 1 ? resolution.split('x')[pivot ? 0 : 1] : '720') : 1
    }
    const classes2 = useOtherStyle(zoomRate);

    const getFileInfo = (id) => {
        setLoading(true)
        dataProvider('GET_ONE', 'categories', {
            id: id
        }).then(({ data }) => {
            setSoundValue(data.fd)
            setLoading(false)
        }).catch(error => {
            console.error('Get list error:', error);
            setLoading(false)
        });
    }

    const getRadioChannel = (id) => {
        setLoading(true)
        dataProvider('GET_ONE', "channel", {
            id
        }).then(({ data, total }) => {
            setSoundValue(data.url)
            setLoading(false)
        }).catch(error => {
            setLoading(false)
        });

    }

    useEffect(() => {
        open && setPresenterData(scheduleData)
        if (!open) {
            clearTimer()
            setSelectedPresenter(0);
        }
        else {
            if (sound) {
                if (sound.type === 'Radio')
                    getRadioChannel(sound.id)
                else
                    getFileInfo(sound.id)
            }
            else
                setSoundValue(null)

        }

    }, [open]);

    useEffect(() => {
        onLoadIframe();
    }, [selectedPresenter])


    const onPrevious = () => {
        clearTimer();
        let selectedPresenterVal = selectedPresenter - 1;
        if (selectedPresenterVal < 0)
            selectedPresenterVal = presenterData.length - 1;
        setSelectedPresenter(selectedPresenterVal);
    };

    const onNext = () => {
        clearTimer();
        if (presenterData && presenterData.length > 0) {
            let selectedPresenterVal = selectedPresenter + 1;
            selectedPresenterVal = selectedPresenterVal % presenterData.length;
            setSelectedPresenter(selectedPresenterVal);
        }
    }

    const onEnded = () => {
        onNext();
    }

    const presentData = () => {
        const data = presenterData[selectedPresenter];
        clearTimer();
        if (data) {
            //RotateAsset(data);
            if (isImage(data.type)) {
                _currentInterval = setInterval(() => {
                    const duration = data.imageShowTime ? data.imageShowTime : 12;
                    if (_stickDisplayTime > duration) {
                        onNext();
                    }
                    _stickDisplayTime++;
                }, 1000);
            }
            else {
                const video = document.getElementById('videoPresenter');
                if (video) {
                    video.removeEventListener('ended', onEnded);
                    video.addEventListener('ended', onEnded);
                    video.play();
                }
            }
        }
    }

    const clearTimer = () => {
        if (_currentInterval) {
            clearInterval(_currentInterval);
            _currentInterval = null;
            _stickDisplayTime = 0;
        }
    }

    const onLoadIframe = () => {
        if (document.getElementById(`overlay-preview-${selectedPresenter}`)) {
            document.getElementById(`overlay-preview-${selectedPresenter}`).contentWindow.document.body.innerHTML = (scheduleData[selectedPresenter].overlay || '');
        }
    }

    return (
        <Dialog open={open} scroll='paper' id="dialogPreviewSchedulePopup" maxWidth='lg' fullWidth={true}>
            <Box display='flex' justifyContent='flex-end' alignContent='center' mr={2} mt={2}>
                <CloseButton onClick={handleClose} />
            </Box>
            <DialogContent>
                {
                    loading ? <Loading />
                        : (
                            <Box>
                                {
                                    soundValue && <audio src={sound.type === 'Radio' ? soundValue : baseAuthUrl + "/media/" + soundValue} id="previewSound" autoPlay loop />

                                }
                                <Box id="presenter" className={classes.DialogContentPresenter} width={screenSize.width} height={screenSize.height}>
                                    <Box display='flex' alignItems='center' height="100%" justifyContent='center' style={{ backgroundColor: '#000' }}>
                                        <PresenterContain presenterData={presenterData[selectedPresenter]} isSound={soundValue ? true : false} classData={classes} presentData={presentData} screenSize={screenSize} pivot={pivot} resolution={resolution} />
                                    </Box>
                                    {
                                        resolution && (
                                            <Iframe src={process.env.PUBLIC_URL + "/infochannel-overlay.html"}
                                                width={resolution.split('x').length > 1 ? resolution.split('x')[pivot ? 1 : 0] : '1280'}
                                                height={resolution.split('x').length > 1 ? resolution.split('x')[pivot ? 0 : 1] : '720'}
                                                id={`overlay-preview-${selectedPresenter}`}
                                                className={classnames(classes.overlayEditor, classes2.zoom)}
                                                onLoad={onLoadIframe} />
                                        )
                                    }
                                </Box>
                                <Box className={classes.ControlPresenter} display="flex" justifyContent="center">
                                    <Button style={{ marginRight: theme.spacing(2) }} variant='contained' color='primary' onClick={onPrevious}><NavigateBefore /></Button>
                                    <Button style={{ marginRight: theme.spacing(2) }} variant='contained' color='primary' onClick={onNext}><NavigateNext /></Button>
                                </Box>
                            </Box>
                        )
                }


            </DialogContent>
        </Dialog>
    );
}

export default PreviewScheduleDialog;